/** Membership roles. `super_admin` is a flag on the account, not a role — the backend refuses to assign it (400). */
export const ROLES: Array<{ value: string; label: string }> = [
  { value: 'owner',        label: 'Владелец' },
  { value: 'admin',        label: 'Администратор' },
  { value: 'manager',      label: 'Менеджер' },
  { value: 'receptionist', label: 'Сотрудник ресепшн' },
  { value: 'housekeeper',  label: 'Горничная' },
];

export const ROLE_LABEL: Record<string, string> = { ...Object.fromEntries(ROLES.map((r) => [r.value, r.label])), super_admin: 'Администратор платформы' };
